// extracted by mini-css-extract-plugin
module.exports = {"new":"index_new_3g4su","favorite":"index_favorite_20OdQ","thumb":"index_thumb_2c4ic","image":"index_image_2fMOc"};